import React from 'react';

import { Grid, Hidden, IconButton } from '@material-ui/core';
import Select from 'react-select';
import { ValueType } from 'react-select/lib/types';
import SearchIcon from '@material-ui/icons/Search';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';

import { Input } from '../../../../../components/Input';
import { PX } from '../../../../../contrib/ui';
import { selectorTheme } from '../../../../../contrib/utils';
import { useBoolean } from '../../../../common/Hooks/useBoolean.hook';
import { useContestSetupDispatch, useContestSetupState } from '../Context/ContestSetup.context';
import { IContestSelectorOption } from '../Context/BoundActionCreators/setContestSelectorOptions';

export const ContestSetupFilters: React.FunctionComponent = () => {
  const [expandedPlayerLookup, , toggleExpandedPlayerLookup] = useBoolean(false);

  const { playerLookupValue, contestSelectorOptions } = useContestSetupState();
  const {
    actions: { search }
  } = useContestSetupDispatch();

  const {
    actions: { selectFormat }
  } = useContestSetupDispatch();

  const selectContest = (contestSelectorOption: ValueType<IContestSelectorOption>) => {
    const {
      value: { metaFormat, scoreType }
    } = contestSelectorOption as IContestSelectorOption;

    selectFormat(scoreType, metaFormat);
  };

  return (
    <Hidden mdUp={true}>
      <Grid
        className="mobile-filters-container"
        container={true}
        alignItems={'center'}
        justify={'center'}
      >
        <Grid className="grid-item" item={true} xs={11}>
          {expandedPlayerLookup ? (
            <Input
              fullWidth={true}
              id="roster-lookup"
              label="PLAYER LOOKUP"
              onChange={search}
              outlined={true}
              placeholder="PLAYER LOOKUP"
              type="search"
              value={playerLookupValue}
            />
          ) : (
            <Select
              className={`autocomplete outlined`}
              maxMenuHeight={180 * PX}
              classNamePrefix="autocomplete"
              onChange={selectContest}
              theme={selectorTheme}
              options={contestSelectorOptions}
              placeholder="SELECT A CONTEST"
            />
          )}
        </Grid>

        <Grid className="grid-item icon-container" item={true} xs={1}>
          <IconButton className="expand-player-lookup" onClick={toggleExpandedPlayerLookup}>
            {expandedPlayerLookup ? (
              <CloseRoundedIcon color="primary" />
            ) : (
              <SearchIcon color="primary" />
            )}
          </IconButton>
        </Grid>
      </Grid>
    </Hidden>
  );
};
